import { createAction } from "@reduxjs/toolkit";
import {
    SHOW_FEEDBACK_LIST_VIEW,
    GET_FEEDBACK_LIST,
    FEEDBACK_LIST_RECEIVED,
    SET_FEEDBACK_PARAMS,
    SELECTED_FEEDBACK_IDS,
    SELECTED_FEEDBACK_COLUMNS,
    TOGGLE_FEEDBACK_ACTION_PERFORMED,
    GET_FEEDBACK_OPTIONS,
    FEEDBACK_OPTIONS_RECEIVED,
    GET_FEEDBACK_TABLE_FILTERS,
    FEEDBACK_TABLE_FILTERS_RECEIVED,
    UPDATE_FEEDBACK,
    ShowFeedbackListViewAction,
    GetFeedbackListAction,
    FeedbackListReceivedAction,
    SetFeedbackParamsAction,
    SelectedFeedbackIdsAction,
    SelectedFeedbackColumnsAction,
    FeedbackOptionsReceivedAction,
    FeedbackTableFiltersReceivedAction,
    UpdateFeedbackAction,
    GET_SEGMENT_FEEDBACK_COMMENTS,
    SEGMENT_FEEDBACK_COMMENTS_RECEIVED,
    POST_SEGMENT_FEEDBACK_COMMENT,
    SEGMENT_FEEDBACK_COMMENT_POSTED,
    GetSegmentFeedbackCommentsAction,
    SegmentFeedbackCommentsReceivedAction,
    PostSegmentFeedbackCommentAction
} from "./types";

export const showFeedbackListView =
    createAction<ShowFeedbackListViewAction["payload"]>(SHOW_FEEDBACK_LIST_VIEW);

export const getFeedbackList = createAction<GetFeedbackListAction["payload"]>(GET_FEEDBACK_LIST);

export const updateFeedback = createAction<UpdateFeedbackAction["payload"]>(UPDATE_FEEDBACK);

export const feedbackListReceived =
    createAction<FeedbackListReceivedAction["payload"]>(FEEDBACK_LIST_RECEIVED);

export const setFeedbackParams =
    createAction<SetFeedbackParamsAction["payload"]>(SET_FEEDBACK_PARAMS);

export const setSelectedFeedbackIds =
    createAction<SelectedFeedbackIdsAction["payload"]>(SELECTED_FEEDBACK_IDS);

export const setSelectedFeedbackColumns =
    createAction<SelectedFeedbackColumnsAction["payload"]>(SELECTED_FEEDBACK_COLUMNS);

export const toggleFeedbackActionPerformed = createAction(TOGGLE_FEEDBACK_ACTION_PERFORMED);

export const getFeedbackOptions = createAction(GET_FEEDBACK_OPTIONS);

export const feedbackOptionsReceived =
    createAction<FeedbackOptionsReceivedAction["payload"]>(FEEDBACK_OPTIONS_RECEIVED);

export const getFeedbackTableFilters = createAction(GET_FEEDBACK_TABLE_FILTERS);

export const feedbackTableFiltersReceived = createAction<
    FeedbackTableFiltersReceivedAction["payload"]
>(FEEDBACK_TABLE_FILTERS_RECEIVED);

export const getSegmentFeedbackComments = createAction<GetSegmentFeedbackCommentsAction["payload"]>(
    GET_SEGMENT_FEEDBACK_COMMENTS
);

export const segmentFeedbackCommentsReceived = createAction<
    SegmentFeedbackCommentsReceivedAction["payload"]
>(SEGMENT_FEEDBACK_COMMENTS_RECEIVED);

export const postSegmentFeedbackComment = createAction<PostSegmentFeedbackCommentAction["payload"]>(
    POST_SEGMENT_FEEDBACK_COMMENT
);

export const segmentFeedbackCommentPosted = createAction(SEGMENT_FEEDBACK_COMMENT_POSTED);
